module.exports = __webpack_public_path__ + "img/yellowDunes.a981ece0.svg";